<template>
 <div>

   <!--   Sozial Kontakt   -->

   <div class="layout-row">
     <div class="flex-gt-sm-33 flex-100 px-2">
       <validation-provider tag="div"
                            :name="path + '.sozialdienstkontakt.datum'"
                            :ref="path + '.sozialdienstkontakt.datum'"
                            rules="german_date|date_not_in_future"
                            v-slot="{ errors }">
         <lx-datepicker
             :color="compColor.textInput"
             :name="path + '.sozialdienstkontakt.datum'"
             :label="$t('FORMS_DIVERSE.MODULE_COMMON_DATE_SOCIAL_SERVICE_CONTACT')"
             class="mr-1"
             @input="resetRadioButtons('sozialdienstkontakt', 'n')"
             :disabled="isDisabled"
             :dense="denseFields"
             :error="errors[0]"
             v-model="model.sozialdienstkontakt.datum"
         ></lx-datepicker>
       </validation-provider>
     </div>

     <div class="flex-gt-sm-66 flex-100 px-2 ml-4 layout-row">
       <validation-provider tag="div"
                            :name="path + '.sozialdienstkontakt.n'"
                            :ref="path + '.sozialdienstkontakt.n'"
                            rules=""
                            v-slot="{ errors }">
         <v-radio-group :dense="denseFields" v-model="model.sozialdienstkontakt.n" row
                        class="pa-0"
                        :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                        :error-messages="errors[0]">
           <v-radio
               :label="$t('FORMS_DIVERSE.MODULE_COMMON_NO_CONTACT')"
               value="N"
               @change="setValuesNull('sozialdienstkontakt')"
               :disabled="isDisabled"
               :color="compColor.primeColor"
               :dark="compColor.isInDarkMode">
           </v-radio>
         </v-radio-group>
       </validation-provider>

       <div>
         <v-btn :color="compColor.primeColor"
                :dark="compColor.isInDarkMode"
                depressed
                text
                width="auto"
                :class="{'mt-0': denseFields, 'mt-1': !denseFields}"
                class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                @click="resetRadioButtons('sozialdienstkontakt', 'n')"
                v-show="model.sozialdienstkontakt.n && !isDisabled"
                :disabled="!model.sozialdienstkontakt.n || isDisabled"
                :title="$t('buttons.deleteSelection.title')">
           <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
           <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
         </v-btn>
       </div>
     </div>
   </div>


   <!--   Psychoonkologiekontakt   -->

   <div class="layout-row">
     <div class="flex-gt-sm-33 flex-100 px-2">
       <validation-provider tag="div"
                            :name="path + '.psychoonkologiekontakt.datum'"
                            :ref="path + '.psychoonkologiekontakt.datum'"
                            rules="german_date|date_not_in_future"
                            v-slot="{ errors }">
         <lx-datepicker
           :color="compColor.textInput"
           :name="path + '.psychoonkologiekontakt.datum'"
           :label="$t('FORMS_DIVERSE.MODULE_COMMON_DATE_PSYCHO_ONKOLOGY_CONTACT')"
           class="mr-1"
           @input="resetRadioButtons('psychoonkologiekontakt', 'n')"
           :disabled="isDisabled"
           :dense="denseFields"
           :error="errors[0]"
           v-model="model.psychoonkologiekontakt.datum"
         ></lx-datepicker>
       </validation-provider>
     </div>

     <div class="flex-gt-sm-66 flex-100 px-2 ml-4 layout-row">
       <validation-provider tag="div"
                            :name="path + '.psychoonkologiekontakt.n'"
                            :ref="path + '.psychoonkologiekontakt.n'"
                            rules=""
                            v-slot="{ errors }">
         <v-radio-group :dense="denseFields" v-model="model.psychoonkologiekontakt.n" row
                        class="pa-0"
                        :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                        :error-messages="errors[0]">
           <v-radio
             :label="$t('FORMS_DIVERSE.MODULE_COMMON_NO_CONTACT')"
             value="N"
             @change="setValuesNull('psychoonkologiekontakt')"
             :disabled="isDisabled"
             :color="compColor.primeColor"
             :dark="compColor.isInDarkMode">
           </v-radio>
         </v-radio-group>
       </validation-provider>

       <div>
         <v-btn :color="compColor.primeColor"
                :dark="compColor.isInDarkMode"
                depressed
                text
                width="auto"
                :class="{'mt-0': denseFields, 'mt-1': !denseFields}"
                class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                @click="resetRadioButtons('psychoonkologiekontakt', 'n')"
                v-show="model.psychoonkologiekontakt.n && !isDisabled"
                :disabled="!model.psychoonkologiekontakt.n || isDisabled"
                :title="$t('buttons.deleteSelection.title')">
           <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
           <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
         </v-btn>
       </div>
     </div>
   </div>

   <!--   Studienrekrutierung   -->

   <div class="layout-row">
     <div class="flex-gt-sm-33 flex-100 px-2">
       <validation-provider tag="div"
                            :name="path + '.studienteilnahme.datum'"
                            :ref="path + '.studienteilnahme.datum'"
                            rules="german_date|date_not_in_future"
                            v-slot="{ errors }">
         <lx-datepicker
             :color="compColor.textInput"
             :name="path + '.studienteilnahme.datum'"
             :label="$t('FORMS_DIVERSE.MODULE_COMMON_DATE_STUDY_CONTACT')"
             class="mr-1"
             @input="resetRadioButtons('studienteilnahme', 'nu')"
             :disabled="isDisabled"
             :dense="denseFields"
             :error="errors[0]"
             v-model="model.studienteilnahme.datum"
         ></lx-datepicker>
       </validation-provider>
     </div>

     <div class="flex-gt-sm-66 flex-100 px-2 ml-4 layout-row">
       <validation-provider tag="div"
                            :name="path + '.studienteilnahme.nu'"
                            :ref="path + '.studienteilnahme.nu'"
                            rules=""
                            v-slot="{ errors }">
         <v-radio-group :dense="denseFields" v-model="model.studienteilnahme.nu" row
                        class="pa-0"
                        :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                        :error-messages="errors[0]">
           <v-radio
               :label="$t('FORMS_DIVERSE.MODULE_COMMON_NO_CONTACT')"
               value="N"
               @change="setValuesNull('studienteilnahme')"
               :disabled="isDisabled"
               :color="compColor.primeColor"
               :dark="compColor.isInDarkMode">
           </v-radio>
           <v-radio
               :label="$t('FORMS_DIVERSE.MODULE_COMMON_CONTACT_UNKNOWN')"
               value="U"
               @change="setValuesNull('studienteilnahme')"
               :disabled="isDisabled"
               :color="compColor.primeColor"
               :dark="compColor.isInDarkMode">
           </v-radio>
         </v-radio-group>
       </validation-provider>

       <div>
         <v-btn :color="compColor.primeColor"
                :dark="compColor.isInDarkMode"
                depressed
                text
                width="auto"
                :class="{'mt-0': denseFields, 'mt-1': !denseFields}"
                class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                @click="resetRadioButtons('studienteilnahme', 'nu')"
                v-show="model.studienteilnahme.nu && !isDisabled"
                :disabled="!model.studienteilnahme.nu || isDisabled"
                :title="$t('buttons.deleteSelection.title')">
           <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
           <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
         </v-btn>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
export default {
  name: "ModulAllgemein",
  props: {
    value: {
      type: Object,
      default: () => ({
        sozialdienstkontakt: {},
        studienteilnahme: {},
        psychoonkologiekontakt: {}
      })
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {
        sozialdienstkontakt: {},
        studienteilnahme: {},
        psychoonkologiekontakt: {}
      }
    }
  },
  methods: {
    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (value, key) {
      this.$set(this.model[value], key, null)
      this.validationRef.fields[this.path + '.' + value + '.' + key].changed = true
    },
    // set values of datum to null if radio button is set
    setValuesNull (value) {
      this.$set(this.model[value], 'datum', null)
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
